import React from 'react';
import './TopBar.css'

const TopBar = (props) => {
    return ( 
        <div className='TopBar'>
            <p className='PageTitle'>{props.PageTitle}</p>

            <div className='BarComps'>
                <input className='SearchBar' type="text" placeholder='Search...' />

                <div className='User'>
                    <p className='UserName'>Saif Hossam</p>
                    <p className='UserEmail'>Saif@Eventick.admin.com</p>
                </div>
            </div>
        </div>
     );
}
 
export default TopBar;